class SearchAutocompleteService {

    route = '';

    constructor($http) {
        'ngInject';

        this.$http = $http;
    }

    setRoute(route) {
        this.route = route;
    }

    matches(query) {
        return this.$http.get(`${this.route}`, {
            params: { q: query }
        });
    }
}

export default SearchAutocompleteService;
